import { useState } from 'react';
import { NB } from '@cerebral-inc/ui';
import BlurryLoadingImage from 'components/shared/blur-image/BlurryLoadingImage';
import HappyWomanPreview from './images/happy-woman.png';
import HappyWoman from './images/happy-woman.svg';
import { TermAndCondition } from './TermAndCondition';
import { AssessmentButton } from '../shared/button';
import { TrustPilot } from './TrustPilot';

const { Heading, Flex, Center, Text, useMediaQuery, Button } = NB;

interface AssessmentIntroProps {
  handleNextPage: () => void;
  condition?: string;
}

const MailingList = ({ handleNextPage, condition }: AssessmentIntroProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isCheckedTerm, setIsCheckedTerm] = useState(false);
  const [isMediumMobile] = useMediaQuery({ minWidth: 415, maxWidth: 768 });
  const [isExtraSmall] = useMediaQuery({ minWidth: 0, maxWidth: 414 });
  const [isMobile] = useMediaQuery({ minWidth: 0, maxWidth: 768 });

  const handleShowResults = () => {
    setIsLoading(true);
    handleNextPage();
  };

  const handleCheckbox = () => {
    setIsCheckedTerm(!isCheckedTerm);
  };

  const isValidForm = () => {
    return isCheckedTerm;
  };

  const getImageHeight = () => {
    if (!isMobile) return '520px';
    return isExtraSmall ? '250px' : '312px';
  };

  const getImageWidth = () => {
    if (!isMobile) return '470px';
    return '100%';
  };

  return (
    <Center w="100%">
      <Flex
        minH={{ base: 'calc(100dvh - 147px)', md: 'auto' }}
        alignItems="center"
        w="100%"
        flexDir={{ base: 'column', md: 'row' }}
        pt={{ base: '0', md: '105px' }}
      >
        <Flex
          w={{ base: '100%', md: '50%' }}
          pr={{ base: '0', md: '64px' }}
          alignItems="flex-end"
        >
          <BlurryLoadingImage
            preview={HappyWomanPreview}
            image={HappyWoman}
            alt="happy-woman"
            width={getImageWidth()}
            height={getImageHeight()}
          />
        </Flex>
        <Flex
          px={{ base: '24px', md: '8px' }}
          position={isMediumMobile ? 'absolute' : 'unset'}
          top="312px"
        >
          <Flex
            w={{ base: '100%', md: '481px' }}
            maxW="481px"
            h={isMediumMobile ? 'calc(100dvh - 371px)' : 'auto'}
          >
            <Heading
              color="c_black.900"
              fontSize={{ base: '20px', md: '22px' }}
              fontWeight="600"
              lineHeight="24px"
              pt={{ base: '24px', md: '0' }}
            >
              Your results are ready
            </Heading>
            <TrustPilot />
            <Text
              color="c_grey.900"
              lineHeight="24px"
              fontWeight="400"
              fontSize={{ base: '14px', md: '16px' }}
            >
              {`Discover if you may be experiencing signs of ${condition}. The results are not meant to be a diagnosis and you should meet with a qualified health professional for a treatment plan unique to you.`}
            </Text>
            <TermAndCondition
              checked={isCheckedTerm}
              onChange={handleCheckbox}
            />
          </Flex>
          <Center w="100%" display={{ base: 'none', sm: 'block' }}>
            <Button
              variant="primary"
              onPress={handleShowResults}
              isDisabled={!isValidForm()}
              isLoading={isLoading}
              mt="32px"
              w="100%"
              h="56px"
              _text={{
                fontSize: '14px',
                fontWeight: 600
              }}
              _disabled={{
                opacity: 1
              }}
            >
              Show results
            </Button>
          </Center>
        </Flex>
      </Flex>
      <AssessmentButton
        marginTop="32px"
        text="Show results"
        isDisabled={!isValidForm()}
        onSubmit={handleShowResults}
        isLoading={isLoading}
        display={{ base: 'block', sm: 'none' }}
        isStickyButton
      />
    </Center>
  );
};

export default MailingList;
